export const FormMixin = {
    data() {
        return {
            loaded: false,
            submitting: false,
            fields: {},
            errors: {}
        }
    },
    methods: {
        hasErrors () {
            return Object.keys(this.errors).length > 0;
        },
        requestSuccess (response) {
            this.errors = {}; // clear errors
            this.fields = {}; // clear fields
            this.submitting = false; // enable submit btn
        },
        requestError (error) {
            this.submitting = false;

            if (error && error.response && error.response.status === 422) {
				this.errors = error.response.data.errors || null;
            }
        }
    }
};
